import { Typography } from '@themenu/design-system'

import Authorize, { PERMISSIONS } from 'components/Authorize'

import { GroupItem, type GroupItemProps } from '../GroupItem'

type MenuItemProps = {
  session_name: string
  session_permissions: PERMISSIONS[]
  session_groups: GroupItemProps[]
}

export const MenuSection = ({
  session_name,
  session_groups
}: MenuItemProps) => {
  return (
    <div>
      <Typography
        component="h4"
        variant="caption"
        className="text-content-subdued px-16 pt-8 pb-4"
      >
        {session_name}
      </Typography>
      {session_groups.map(
        ({
          group_name,
          group_permissions,
          icon,
          group_list,
          href,
          id,
          target_new,
          action
        }) => {
          return (
            <Authorize key={group_name} permissions={group_permissions}>
              <GroupItem
                group_name={group_name}
                group_permissions={group_permissions}
                icon={icon}
                group_list={group_list}
                href={href}
                id={id}
                target_new={target_new}
                action={action}
              />
            </Authorize>
          )
        }
      )}
    </div>
  )
}
